import {
  V3_SET_PRODUCT_CONFIG,
  V3_CLEAR_PRODUCT_CONFIG,
  V3_ADD_TO_CART,
  V3_MARK_RETOUCHING_PROMPTED,
  V3_DECLINE_RETOUCHING,
  V3_DECLINE_INTERSTITIAL_PRODUCT,
  V3_DECLINE_PRE_CART_OFFER_PRODUCT,
  V3_MARK_PRE_CART_OFFER_PRODUCT_AS_PROMPTED,
  V3_STORE_CART,
  V3_STORE_CART_ERROR,
  V3_STORE_CART_SUCCESS,
  V3_SUBMITTING_CART,
  V3_SUBMIT_CART_SUCCESS,
  V3_SUBMIT_CART_ERROR,
  V3_CLEAR_CART,
  V3_REMOVE_CART_ITEM,
  V3_RESET_RETOUCHING,
  V3_UPDATE_SMS_NUMBER_CONFIRMED,
  V3_POP_ITEM_FROM_CONFIG,
  V3_REMOVE_ITEM_FROM_CONFIG,
  V3_SET_PERSONALIZATION_ON_ALL_ELIGIBLE_CART_ITEMS,
  V3_SKIP_PERSONALIZATION_ON_ALL_CART_ITEMS,
  V3_CHECKOUT_LOADING,
  V3_APPLY_DISCOUNT_CODE_TO_CART,
  V3_RESET_SUBMITTING_ORDER,
  V3_CONFIRM_SHIPPING_ADDRESS,
  V3_SET_ACCEPTED_PICS_PLUS,
  V3_SET_CART_UUID,
} from '../../actions/v3Order';
import cartUtils from '../../utils/cart';
import { handleAddToCart } from './handleAddToCart';

const INITIAL_STATE = {
  acceptedPicsPlus: false,
  cartTotals: {
    total: 0,
    shipping: 0,
    tax: 0,
    discount: 0,
    familyDiscount: 0,
    grandTotal: 0,
  },
  checkoutIsLoading: false,
  discountCodes: [],
  offerPicsPlus: false,
  isPicsPlusMember: false,
  picsPlusSubscriptionInfo: null,
  picsPlusExperiment: null,
  subscriberCount: 0,
  offeredPicsPlus: false,
  orders: {},
  productConfig: {},
  shippingAddressConfirmed: false,
  smsNumberConfirmed: false,
  storingCart: false,
  submittingOrder: false,
  uuid: null,
};

export default function (state = INITIAL_STATE, action) {
  Object.freeze(state);

  let existing;

  switch (action.type) {
    case V3_ADD_TO_CART:
      return handleAddToCart(state, action.payload);
    case 'V3_DECLINE_PERSONALIZATION': {
      const orderKey = action.payload.orderKey;
      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: {
            ...state.orders[orderKey],
            personalization: {
              ...state.orders[orderKey].personalization,
              shouldPrompt: false,
            },
          },
        },
      };
    }

    case 'V3_SUBMIT_PERSONALIZATION': {
      const orderKey = action.payload.orderKey;
      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: {
            ...state.orders[orderKey],
            personalization: {
              value: action.payload.value,
              shouldPrompt: false,
            },
          },
        },
      };
    }
    case V3_SET_PERSONALIZATION_ON_ALL_ELIGIBLE_CART_ITEMS: {
      const orderKey = action.payload.orderKey;
      const submittedPersonalizationValue = action.payload.personalizationValue;

      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: {
            ...state.orders[orderKey],
            cartItems: state.orders[orderKey].cartItems.map((item) => {
              if (
                item.personalizationStatus === 'personalization_optional' ||
                item.personalizationStatus === 'personalization_required'
              ) {
                return {
                  ...item,
                  personalizationValue: submittedPersonalizationValue,
                };
              }

              // Check childProducts
              if (item.children) {
                const updatedChildProducts = item.children.map((childItem) => {
                  if (
                    childItem.personalizationStatus ===
                      'personalization_optional' ||
                    childItem.personalizationStatus ===
                      'personalization_required'
                  ) {
                    return {
                      ...childItem,
                      personalizationValue: submittedPersonalizationValue,
                    };
                  }
                  return childItem;
                });
                return { ...item, children: updatedChildProducts };
              }

              return item;
            }),
            personalization: {
              value: submittedPersonalizationValue,
              shouldPrompt: false,
            },
          },
        },
      };
    }
    case V3_SKIP_PERSONALIZATION_ON_ALL_CART_ITEMS: {
      const orderKey = action.payload.orderKey;

      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: {
            ...state.orders[orderKey],
            cartItems: state.orders[orderKey].cartItems.map((item) => {
              if (
                item.personalizationStatus === 'personalization_optional' ||
                item.personalizationStatus === 'personalization_required'
              ) {
                return {
                  ...item,
                  personalizationValue: null,
                };
              }

              // Check childProducts
              if (item.children) {
                const updatedChildProducts = item.children.map((childItem) => {
                  if (
                    childItem.personalizationStatus ===
                      'personalization_optional' ||
                    childItem.personalizationStatus ===
                      'personalization_required'
                  ) {
                    return {
                      ...childItem,
                      personalizationValue: null,
                    };
                  }
                  return childItem;
                });
                return { ...item, children: updatedChildProducts };
              }

              return item;
            }),
            personalization: {
              value: null,
              shouldPrompt: false,
            },
          },
        },
      };
    }
    case V3_MARK_RETOUCHING_PROMPTED:
    case V3_DECLINE_RETOUCHING: {
      const { orderKey } = action.payload;
      const order = state.orders[orderKey];

      if (!order) {
        return state;
      }

      const updatedOrder = {
        ...order,
        retouching: {
          ...order.retouching,
          shouldPrompt: false,
        },
      };

      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: updatedOrder,
        },
      };
    }
    case V3_DECLINE_INTERSTITIAL_PRODUCT: {
      const { orderKey } = action.payload;
      const { productId } = action.payload;
      const order = state.orders[orderKey];

      if (!order) {
        return state;
      }

      const promptedProducts = order.interstitialProductsPrompted || [];
      const productAlreadyExists = promptedProducts.includes(productId);

      const updatedOrder = {
        ...order,
        interstitialProductsPrompted: productAlreadyExists
          ? promptedProducts
          : [...promptedProducts, productId],
      };

      return {
        ...state,
        orders: {
          ...state.orders,
          [orderKey]: updatedOrder,
        },
      };
    }
    case V3_DECLINE_PRE_CART_OFFER_PRODUCT:
    case V3_MARK_PRE_CART_OFFER_PRODUCT_AS_PROMPTED: {
      {
        const { orderKey } = action.payload;
        const { productId } = action.payload;
        const order = state.orders[orderKey];

        if (!order) {
          return state;
        }

        const promptedProducts = order.preCartOfferProductsPrompted || [];
        const productAlreadyExists = promptedProducts.includes(productId);

        const updatedOrder = {
          ...order,
          preCartOfferProductsPrompted: productAlreadyExists
            ? promptedProducts
            : [...promptedProducts, productId],
        };

        return {
          ...state,
          orders: {
            ...state.orders,
            [orderKey]: updatedOrder,
          },
        };
      }
    }
    case V3_SUBMIT_CART_ERROR: {
      return {
        ...state,
        submittingOrder: false,
      };
    }
    case V3_SUBMIT_CART_SUCCESS: {
      return {
        ...state,
        submittingOrder: false,
      };
    }
    case V3_SUBMITTING_CART: {
      return {
        ...state,
        submittingOrder: true,
      };
    }
    case V3_STORE_CART: {
      return {
        ...state,
        storingCart: true,
      };
    }
    case V3_STORE_CART_ERROR: {
      return {
        ...state,
        storingCart: false,
      };
    }
    case V3_STORE_CART_SUCCESS: {
      return {
        ...state,
        storingCart: false,
        cartTotals: action.payload.cartTotals,
        offerPicsPlus: action.payload.offerPicsPlus,
        isPicsPlusMember: action.payload.isPicsPlusMember || false,
        picsPlusSubscriptionInfo:
          action.payload.picsPlusSubscriptionInfo || null,
        picsPlusExperiment: action.payload.picsPlusExperiment || null,
        subscriberCount: action.payload.subscriberCount || 0,
      };
    }
    case V3_SET_PRODUCT_CONFIG: {
      const {
        index,
        isPrepay,
        itemToAdd,
        prepayRequiresSameValuePersonalization,
      } = action.payload;

      const itemToAddKey = Object.keys(itemToAdd)[0];

      let productConfig;

      // If the shoot is prepay and prepay requires the same value for personalization
      // across all cart items, ensure the config is updated with the same value for each
      // child product's personalization.
      if (
        itemToAddKey?.toLowerCase() === 'personalization' &&
        isPrepay &&
        prepayRequiresSameValuePersonalization &&
        itemToAdd.personalization !== undefined &&
        itemToAdd.personalization !== null &&
        itemToAdd.personalization !== ''
      ) {
        productConfig = Object.entries(state.productConfig).reduce(
          (newProductConfig, [key, value]) => {
            return {
              ...newProductConfig,
              [key]: {
                ...value,
                personalization:
                  value.personalization !== undefined &&
                  value.personalization !== null
                    ? itemToAdd.personalization
                    : value.personalization,
              },
            };
          },
          {},
        );
      } else {
        // If the conditions aren't met, just use the original productConfig
        productConfig = state.productConfig;
      }
      return {
        ...state,
        productConfig: {
          ...productConfig,
          [index]: productConfig[index]
            ? {
                ...productConfig[index],
                ...itemToAdd,
              }
            : itemToAdd,
        },
      };
    }
    case V3_POP_ITEM_FROM_CONFIG:
      existing = { ...state };
      if (!existing.productConfig[action.payload.index]) return existing;
      if (!existing.productConfig[action.payload.index][action.payload.section])
        return existing;
      delete existing.productConfig[action.payload.index][
        action.payload.section
      ];
      return existing;
    case V3_REMOVE_ITEM_FROM_CONFIG:
      existing = { ...state };
      const keys = Object.keys(
        existing.productConfig[action.payload.index],
      ).length;
      Object.keys(existing.productConfig).forEach((key, index) => {
        if (index < action.payload.index) return;
        else if (existing.productConfig[index + 1])
          existing.productConfig[index] = existing.productConfig[index + 1];
        else delete existing.productConfig[index];
      });
      action.payload.history.go(-keys);
      return existing;
    case V3_CLEAR_PRODUCT_CONFIG:
      let productConfig;

      if (action.payload) {
        productConfig = {
          ...state.productConfig,
          [action.payload]: [],
        };
      } else {
        productConfig = {};
      }

      return {
        ...state,
        productConfig,
      };
    case V3_CLEAR_CART: {
      return {
        ...state,
        cartTotals: {},
        discountCodes: [],
        orders: {},
        shippingAddressConfirmed: false,
        uuid: null,
      };
    }
    case V3_SET_CART_UUID: {
      if (state.uuid) return state;
      return {
        ...state,
        uuid: action.payload,
      };
    }
    case V3_REMOVE_CART_ITEM: {
      const { orderKey, cartItemId } = action.payload;
      const studentOrder = state.orders[orderKey];

      if (!studentOrder) {
        return state; // No changes, orderKey not found.
      }

      const cartItemToRemove = studentOrder.cartItems.find(
        (item) => item.id === cartItemId,
      );

      if (!cartItemToRemove) {
        return state; // No changes, cartItemId not found.
      }

      let updatedCartItems = studentOrder.cartItems;

      if (cartItemToRemove.isPersonalization) {
        // Iterate through all other items in the order and set personalizationValue to null,
        // also handle the child items if they exist.
        updatedCartItems = studentOrder.cartItems.map((item) => ({
          ...item,
          personalizationValue: null,
          children: item.children
            ? item.children.map((childItem) => ({
                ...childItem,
                personalizationValue: null,
              }))
            : item.children,
        }));
      }

      // TODO: seems like we can remove this, but need to test
      const newCartItemIds = studentOrder.cartItemIds.filter(
        (id) => id !== cartItemId,
      );

      const newCartItems = updatedCartItems.filter(
        (item) => item.id !== cartItemId,
      );

      // Remove the productId from interstitialProductsPrompted if it exists.
      const newInterstitialProductsPrompted =
        studentOrder.interstitialProductsPrompted.filter(
          (id) => id !== cartItemToRemove.productId,
        );

      // Compute the total sum of the non-incentive cart items.
      const totalNonIncentiveCartItems = newCartItems.reduce(
        (total, item) => total + (item.isIncentive ? 0 : item.price),
        0,
      );

      // Remove any incentive items where the incentiveThreshold is lower than
      // the new sum of non-incentive cart items.
      let filteredIncentiveCartItems = newCartItems.filter(
        (item) =>
          !item.isIncentive ||
          item.incentiveThreshold <= totalNonIncentiveCartItems,
      );

      const allIncentiveItems = filteredIncentiveCartItems.every(
        (item) => item.isIncentive,
      );

      // If all remaining items are incentive items, set filteredIncentiveCartItems to an empty array
      if (allIncentiveItems) {
        filteredIncentiveCartItems = [];
      }

      const filteredIncentiveCartItemIds = filteredIncentiveCartItems.map(
        (item) => item.id,
      );

      // Create new studentOrder with updated cartItemIds and cartItems.
      const newStudentOrder = {
        ...studentOrder,
        cartItemIds: filteredIncentiveCartItemIds,
        cartItems: filteredIncentiveCartItems,
        interstitialProductsPrompted: newInterstitialProductsPrompted,
      };

      const newOrders = { ...state.orders, [orderKey]: newStudentOrder };

      // If cartItems is empty, delete the order
      if (filteredIncentiveCartItems.length === 0) {
        delete newOrders[orderKey];
      }

      return {
        ...state,
        orders: newOrders,
      };
    }
    case V3_RESET_RETOUCHING: {
      const { orderKey } = action.payload;
      const studentOrder = state.orders[orderKey];

      if (!studentOrder) {
        return state; // No changes, orderKey not found.
      }

      const newRetouching = studentOrder.retouching;
      newRetouching.shouldPrompt = true;

      const newStudentOrder = {
        ...studentOrder,
        retouching: newRetouching,
      };

      const newOrders = { ...state.orders, [orderKey]: newStudentOrder };

      return {
        ...state,
        orders: newOrders,
      };
    }
    case V3_UPDATE_SMS_NUMBER_CONFIRMED: {
      return {
        ...state,
        smsNumberConfirmed: action.payload,
      };
    }
    case V3_CHECKOUT_LOADING: {
      const { checkoutIsLoading } = action.payload;

      return {
        ...state,
        checkoutIsLoading,
      };
    }
    case V3_APPLY_DISCOUNT_CODE_TO_CART: {
      return cartUtils.applyDiscountCodeToCart(state, action.payload.data);
    }
    case V3_RESET_SUBMITTING_ORDER: {
      return {
        ...state,
        submittingOrder: false,
      };
    }
    case V3_CONFIRM_SHIPPING_ADDRESS: {
      return {
        ...state,
        shippingAddressConfirmed: true,
      };
    }
    case V3_SET_ACCEPTED_PICS_PLUS: {
      const { accepted } = action.payload;
      return {
        ...state,
        acceptedPicsPlus: accepted,
        offeredPicsPlus: true,
      };
    }
    default:
      return state;
  }
}
